<template>
  <div class="fast-help-modal">
    <div class="fast-help-modal-content">
      <h3 class="mt-0 text-lg font-medium text-neutral-700">
        Trouvez un graphiste parmi plus de 30&nbsp;000 professionnels
      </h3>
      <p class="text-muted">
        Votre annonce sera publiée gratuitement et visible auprès des milliers de graphistes professionnels. Vous recevrez
        une dizaine de propositions en quelques minutes.
      </p>
      <p>
        <span class="bg-primary-gradient bg-clip-text text-xl font-medium text-transparent">
          Rapide, gratuit et sans engagement
        </span>
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@media (min-width: 768px) {
  .fast-help-modal {
    .webp & {
      background-image: url('../images/marketing-message-bg.webp');
    }
    .no-compressedimage & {
      background-image: url('../images/marketing-message-bg.png');
    }
  }
}
</style>
